// Current feeds quote_plus the whole URL; older cached feeds contain raw URLs.
function thumbnailUrl(value) {
    if (typeof value !== 'string' || !value) {
        return null;
    }
    let url = value;
    if (/^https?%3a%2f%2f/i.test(url)) {
        try {
            url = decodeURIComponent(url.replace(/\+/g, ' '));
        } catch (error) {
            return null;
        }
    }
    if (!/^https?:\/\//i.test(url) || /[\u0000-\u001f\u007f]/.test(url) || /%(?![0-9a-f]{2})/i.test(url)) {
        return null;
    }
    try {
        const parsed = new URL(url);
        if (!parsed.hostname || parsed.username || parsed.password) {
            return null;
        }
    } catch (error) {
        return null;
    }
    // Preserve existing escapes and signatures rather than normalizing the URL.
    return url;
}

export { thumbnailUrl };
